import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { generateOrderItem } from "../helpers/common";
import { getImageName } from "../api/iposApi";
import IPosModal from "../IPosModal";
import Image from './Image';
import ItemInfo from "./ItemInfo";
import ItemAdditions from "./ItemAdditions";
import ItemQuantity from "./ItemQuantiry";
import ItemAddToCardBtn from "./ItemAddToCardBtn";

import "./OrderItem.scss";

const OrderItem = ({
  menuItem,
  category,
  relation,
  currentOrderItem,
  selectedItemSupplements,
  itemInstructions,
  t,
  menuItemTypes,
  onlyAdditions = false,
  addToCart,
  deleteFromCart,
  close,
  showCloseButton = false,
  currentLanguageId,
  branchInfo,
}) => {
  const [orderItem, updateOrderItem] = useState(
    menuItem
      ? currentOrderItem
        ? currentOrderItem
        : generateOrderItem(menuItem, menuItemTypes, {
            category: category,
            relation: relation,
          })
      : null
  );
  const [selectedSupplements, setSelectedSupplements] = useState(
    currentOrderItem ? currentOrderItem.supplements : []
  );
  const [selectedInstructions, setSelectedInstructions] = useState(
    currentOrderItem ? currentOrderItem.instructions : []
  );
  const [currentQuantity, setCurrentQuantity] = useState(
    currentOrderItem ? currentOrderItem.orderItem.quantity : 1
  );
  const [currentFreeInstruction, setCurrentFreeInstruction] = useState(
    currentOrderItem ? currentOrderItem.freeInstruction : ""
  );

  //const isMobile = isMobileAndTablet();

  const onSelectSupplement = (supplement) => {
    if (
      menuItem.is_pizza_item_flg === 1 &&
      !selectedSupplements.some(
        (i) => i.menuItem.menu_item_id === supplement.menu_item_id
      )
    ) {
      if (!allowedToAddSupplements()) {
        return;
      }
    }

    // if (menuItem.is_pizza_item_flg === 1) {
    //   IPosModal.pizzaPart({
    //     supplement: supplement,
    //     onOk: (chosenSupplement) => {
    //       processSelectedSupplement(chosenSupplement);
    //     },
    //     onDelete: (supplement) => {
    //       removeSelectedSupplement(supplement);
    //     }
    //   });
    //   return;
    // }

    processSelectedSupplement(supplement);
  };

  const processSelectedSupplement = (supplement) => {
    if (
      selectedSupplements.some(
        (i) => i.menuItem.menu_item_id === supplement.menu_item_id
      )
    ) {
      if (menuItem.is_pizza_item_flg === 1) {
        const newSelectedSupplements = selectedSupplements.map((s) => {
          if (s.menuItem.menu_item_id === supplement.menu_item_id) {
            return generateOrderItem(supplement, menuItemTypes, {
              customPrice: null,
              newQuantity: orderItem.orderItem.quantity,
              category: category,
            });
          }
          return s;
        });

        setSelectedSupplements([...newSelectedSupplements]);
      } else {
        removeSelectedSupplement(supplement);
      }
    } else {
      const orderSupplement = generateOrderItem(supplement, menuItemTypes, {
        customPrice: null,
        newQuantity: orderItem.orderItem.quantity,
        category: category,
      });
      if (allowedToAddSupplements()) {
        setSelectedSupplements([...selectedSupplements, orderSupplement]);
      }
    }
  };

  const allowedToAddSupplements = () => {
    return (
      orderItem.menuItem.max_supplement_qty === 0 ||
      getSupplementsQuantity() + 1 <= orderItem.menuItem.max_supplement_qty
    );
  };

  const removeSelectedSupplement = (supplement) => {
    setSelectedSupplements(
      selectedSupplements.filter(
        (i) => i.menuItem.menu_item_id !== supplement.menu_item_id
      )
    );
  };

  const getSupplementsQuantity = () => {
    return selectedSupplements.length;
  };

  const onSelectInstructions = (instruction) => {
    if (
      selectedInstructions.some(
        (i) => i.menuItem.menu_item_id === instruction.menu_item_id
      )
    ) {
      setSelectedInstructions(
        selectedInstructions.filter(
          (i) => i.menuItem.menu_item_id !== instruction.menu_item_id
        )
      );
    } else {
      const orderInstruction = generateOrderItem(instruction, menuItemTypes, {
        category: category,
      });
      setSelectedInstructions([...selectedInstructions, orderInstruction]);
    }
  };

  useEffect(() => {
    updateOrderItem(
      Object.assign({}, orderItem, { supplements: selectedSupplements })
    );
  }, [selectedSupplements]);

  useEffect(() => {
    updateOrderItem(
      Object.assign({}, orderItem, { instructions: selectedInstructions })
    );
  }, [selectedInstructions]);

  useEffect(() => {
    updateOrderItem(
      Object.assign({}, orderItem, { freeInstruction: currentFreeInstruction })
    );
  }, [currentFreeInstruction]);

  useEffect(() => {
    const tmpItem = Object.assign({}, orderItem);
    tmpItem.orderItem.quantity = currentQuantity;
    for (const supplement of tmpItem.supplements) {
      supplement.orderItem.quantity = currentQuantity;
    }

    updateOrderItem(tmpItem);
  }, [currentQuantity]);

  const onAddToCart = () => {
    orderItem.supplements = selectedSupplements;
    orderItem.instructions = selectedInstructions;
    orderItem.freeInstruction = currentFreeInstruction;

    const [valid, message] = isValid();

    if (!valid) {
      IPosModal.alert({
        title: t("add_item_modal.errors.title"),
        message: message,
        okButtonText: t("buttons.ok"),
        cancelButtonText: t("buttons.cancel"),
        onOk: () => {},
      });

      return;
    }

    addToCart(orderItem);
    close();
  };

  const deleteItem = () => {
    if (deleteFromCart) {
      deleteFromCart(orderItem);
    }
    close();
  };

  const isValid = () => {
    // Min Supplement Rule
    if (
      orderItem.menuItem.min_supplement &&
      orderItem.menuItem.min_supplement > 0
    ) {
      const minSupplements = orderItem.menuItem.min_supplement;
      if (orderItem.supplements.length < minSupplements) {
        return [
          false,
          t("add_item_modal.errors.min_supplements", {
            minSupplements: minSupplements,
          }),
        ];
      }
    }

    if (orderItem.menuItem.is_use_inctraction_flg !== 0) {
      // 0 - NotUse,
      // 1 - UseInstraction,
      // 2 - UseSupplement,
      // 3 - UseInstractionAndSupplement
      if (
        orderItem.menuItem.is_use_inctraction_flg === 1 &&
        orderItem.instructions.length === 0
      ) {
        return [false, t("add_item_modal.errors.at_least_instruction")];
      }

      if (
        orderItem.menuItem.is_use_inctraction_flg === 2 &&
        orderItem.supplements.length === 0
      ) {
        return [false, t("add_item_modal.errors.at_least_supplement")];
      }

      if (
        orderItem.menuItem.is_use_inctraction_flg === 3 &&
        (orderItem.supplements.length === 0 ||
          orderItem.instructions.length === 0)
      ) {
        return [
          false,
          t("add_item_modal.errors.at_least_supplement_and_instruction"),
        ];
      }
    }

    return [true, ""];
  };

  const mobileLayout = () => {
    return (
      <div className={"add-item-content mobile-layout"}>        
        <div className={"item-mobile-content"}>
          <div
            className={"close-modal"}
            onClick={() => {
              close();
            }}
          >
            <FontAwesomeIcon icon="chevron-down" />
          </div>
            <Image image={getImageName(branchInfo, orderItem.menuItem)} useDefaultEmpty = {true} onClickEvent = {close} />
          <div className={"dialog-item-info"}>
            <ItemInfo
              orderItem={orderItem}
              currentLanguageId={currentLanguageId}
            />
          </div>
          <div className={"item-additions-side"}>
            <ItemAdditions
              t={t}
              branchInfo={branchInfo}
              itemInstructions={itemInstructions}
              selectedInstructions={selectedInstructions}
              onSelectInstructions={onSelectInstructions}
              selectedItemSupplements={selectedItemSupplements}
              selectedSupplements={selectedSupplements}
              onSelectSupplement={onSelectSupplement}
              currentFreeInstruction={currentFreeInstruction}
              changeFreeInstruction={setCurrentFreeInstruction}
              removeSelectedSupplement={removeSelectedSupplement}
              isPizza={menuItem.is_pizza_item_flg === 1}
            />
          </div>          
        </div> 
        <div className={"add-item-actions"}>
          <ItemQuantity
            item={orderItem}
            currentQuantity={currentQuantity}
            updateQuantity={setCurrentQuantity}
          />
          {/* {currentOrderItem && (
            <div className={"btn btn-danger"} onClick={deleteItem}>
              <FontAwesomeIcon icon={"trash"} />
            </div>
          )} */}
          <ItemAddToCardBtn
            t={t}
            orderItem={orderItem}
            isNewItem={!currentOrderItem}
            onAddToCart={onAddToCart}
          />
        </div>      
      </div>
    );
  };

  return <>{mobileLayout()}</>;
};

export default OrderItem;
